/// <reference path="../../ng-services/chat.service.ts"/>

import { ChatAttachmentUploadService } from '../../ng-services/chat-attachment-upload.service';
import { MeetingsStore } from '../../ng-services/meetings.store';

(function () {
    angular.module('tradersyard').directive('tyChatUploadDragAndDrop', [
        'MeetingsStore',
        'ChatAttachmentUploadService',
        function (meetingsStore: MeetingsStore, chatAttachmentUploadService: ChatAttachmentUploadService) {
            function link(scope: ng.IScope, element: ng.IAugmentedJQuery) {
                const e = element[0];

                e.addEventListener('drop', (event: any) => {
                    event.preventDefault();

                    const files: File[] = [];

                    if (event.dataTransfer.items) {
                        // Use DataTransferItemList interface to access the file(s)
                        for (let i = 0; i < event.dataTransfer.items.length; i++) {
                            // If dropped items aren't files, reject them
                            if (event.dataTransfer.items[i].kind === 'file') {
                                const file = event.dataTransfer.items[i].getAsFile();
                                files.push(file);
                            }
                        }
                    } else {
                        // Use DataTransfer interface to access the file(s)
                        for (let i = 0; i < event.dataTransfer.files.length; i++) {
                            files.push(event.dataTransfer.files[i]);
                        }
                    }

                    // todo: refactor
                    meetingsStore.activeMeeting$
                        .take(1)
                        .subscribe((meeting) =>
                            files.forEach((file) => meeting && chatAttachmentUploadService.upload(meeting, file))
                        );
                });
                e.classList.add('chat_upload_drag_and_drop');

                let styleTimeoutHandle: any;

                e.addEventListener('dragover', (event) => {
                    event.preventDefault();

                    clearTimeout(styleTimeoutHandle);

                    e.classList.add('is-active');

                    styleTimeoutHandle = setTimeout(() => e.classList.remove('is-active'), 2000);
                });
            }

            return {
                link,
                transclude: true,
                template: `<ng-transclude/>`,
            };
        },
    ]);
})();
